import { HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { ClientKind, TinKind } from '@skylab-shared/dataModel';
import { EmailUtils } from '../../common/email-utils';
import { PagedCollectionQuery, PagedCollectionQueryResult, PagedCollectionQueryResultDTO } from './../../common/query/paged-collection-query';

export type ClientGridItem = Omit<ClientGridItemDTO, 'emails'> & {
    emails?: string[];
};

class ClientGridItemDTO {
    public readonly address: string;
    public readonly city: string;
    public readonly country: string;
    public readonly favourite: boolean;
    public readonly groupId: string;
    public readonly id: number;
    public readonly kind: ClientKind;
    public readonly name: string;
    public readonly tin: string;
    public readonly tinKind: TinKind;
    public readonly version: string;
    public readonly zipCode: string;
    public readonly phone1?: string;
    public readonly phone2?: string;
    public readonly emails?: string;
    public readonly externalId: string;
}

export class ClientGridCollectionQuery extends PagedCollectionQuery<ClientGridItem> { }

export class ClientGridCollectionQueryHandlerBase implements QueryHandler<ClientGridCollectionQuery, PagedCollectionQueryResult<ClientGridItem>> {
    private static Url = TaggedUrl.join('clients', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(query: ClientGridCollectionQuery): Promise<PagedCollectionQueryResult<ClientGridItem>> {
        const { data } = await this.http.get(ClientGridCollectionQueryHandlerBase.Url, {
            params: { ...query.params },
            dtoObject: new PagedCollectionQueryResultDTO<ClientGridItemDTO>(ClientGridItemDTO)
        });

        const items = data.items?.map(elem => ({
            ...elem,
            emails: EmailUtils.extractEmails(elem.emails)
        }));

        return {
            totalItemsCount: data.totalItemsCount,
            items: items
        };
    }
}
